
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getNeonKeys, setJWT } from '../../lib/api';

const Login = () => {

  let navigate = useNavigate();

  useEffect( () => {
    let isSubscribed = true;

    const signIn = async () => {
  
      const response = await getApiKey();
    
      const params = {
        abbreviation: 'APA',
        apiKey: response.apiKey,
        neonClientName: 'academicpeds',
        neonOauthId: response.neonOauthId,
        neonOauthSecret: response.neonOauthSecret
      };

      const { token } = await setJWT( params );
      document.cookie = `auth_code=${token};max-age=604800;domain=${process.env.REACT_APP_DOMAIN}`;
      navigate( '/authenticate' );
    };

    if ( isSubscribed ) {
      signIn();
    }

    return () => isSubscribed = false;
  }, [navigate] );

  const getApiKey = async () => {
    const postParams = {
        apiKey: process.env.REACT_APP_ADMIN_API_KEY
    };
    const result = await getNeonKeys(postParams);

    return result;
};

  return (
    <div>
      <p>Redirecting to login...</p>
    </div>
  );
};

export default Login;